module.exports = __webpack_public_path__ + "img/domonetizationApprove.1f3fb89f.svg";